import Client from './KomodoClient';

// komodo CustomFileRelationController (api/customfile-relation): the media library. Every call is
// per tag (CustomFileTagEnum name); the list has no paging. Delete removes the relation only.
const enc = encodeURIComponent;

// { tagName, deptCode?, fileName?, activeRelationCode? } → CustomFileRelationDTO[] (dept-specific + global)
const queryList = (query) =>
	Client.post('/api/customfile-relation/query-list', query);
// Absolute URLs of a tag's images (anonymous endpoint; dept from the BranchId header).
const imageUrls = (tagName) =>
	Client.get(`/api/customfile-relation/${enc(tagName)}/images/query-list`);
const create = (tagName, dto) =>
	Client.post(`/api/customfile-relation/tag/${enc(tagName)}`, dto);
const update = (tagName, fileID, dto) =>
	Client.put(
		`/api/customfile-relation/tag/${enc(tagName)}/${enc(fileID)}`,
		dto
	);
const remove = (tagName, fileID) =>
	Client.del(`/api/customfile-relation/tag/${enc(tagName)}/${enc(fileID)}`);

export default { queryList, imageUrls, create, update, remove };
